<template>
	<div class="pt-4">
		<div v-if="$route.name === 'job-evaluation-processes-commitees'">
			<app-table
				icon-excel
				title="Comites"
				:rows="rows"
				:columns="columns"
				:filter-columns="false"
				class="is-not-selectable no-main-list"
				@on-search-event="onSearch"
			>
				<template slot="excel">
					<app-button class="new-tool" icon="add" @click="goTo('new-commitees')"/>
				</template>
				<template slot="rows" slot-scope="props">
					<td v-show="showRow(columns, 1)" class="is-not-selectable border-top text-left">{{ props.row.name }}</td>
					<td v-show="showRow(columns, 2)" class="is-not-selectable border-top">{{ props.row.createdAt | formatDate }}</td>
					<td v-show="showRow(columns, 3)" class="is-not-selectable border-top">{{ props.row.totalEmployees }}</td>
					<td v-show="showRow(columns, 4)" class="is-not-selectable border-top">
						<button @click="openDialogQuantity(props.row)" class="text-blue">
						  {{ props.row.totalEmployeesResolved }} / {{ props.row.totalEmployees }}
						</button>
					</td>
					<td v-show="showRow(columns, 5)" class="is-not-selectable border-top">
						<app-tooltip-button
							text="Editar"
							img="https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/new-file-1-(4).svg"
							@click-icon="editCommitee(props.row)"
						/>
						<app-tooltip-button
							img="https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/delete-button-(1).svg"
							text="Eliminar"
							color="info"
							@click-icon="openModalCom('delete', props.row.id, props.row.name)"
						/>
					</td>
				</template>
			</app-table>
			<v-dialog v-model="isVisible" persistent max-width="910">
				<v-card>
					<div class="tw-flex tw-w-full tw-justify-end tw-px-4">
						<button
						@click="closeDialog"
						:style="`color:${$appColors.secondary};font-size: 25px;`">x</button>
					</div>
					<table border="0" cellpadding="0" cellspacing="0">
						<thead>
							<tr>
								<th scope="row">
									<div class="triangle-right">
										<span class="label-pue">Puesto</span>
									</div>
									<div class="triangle-left">
										<span class="label-val">
											Valores
										</span>
									</div>
								</th>
								<th
								class="text-primary tw-py-5 tw-px-5 tw-text-center"
								:style="`border-bottom: 1px solid ${$appColors.gray};font-size: 12px;`"
								v-for="(item, index) in arrayJobs" :key="index">
									{{ item.name }}
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in arrayEmployes" :key="index">
								<td
								:style="`border-right: 2px solid ${$appColors.primary};border-bottom: 1px solid ${$appColors.gray};font-size: 12px;`"
								class="text-info tw-text-center tw-py-5 tw-px-5">
									{{ item.name }}
								</td>
								<td :style="`${$appColors.gray}; font-size: 14px;border-bottom: 1px solid ${$appColors.gray};`"
								class="tw-text-center tw-py-5 tw-px-5"
								v-for="(item, index) in arrayDiagnostic" :key="index">
										{{item[index].average}}
								</td>
							</tr>
						</tbody>
						<tfoot></tfoot>
					</table>
				</v-card>
			</v-dialog>
			<open-modal
				:dialog="openDialog"
				:title="title"
				:create="!this.action === 'delete'"
				@close-modal="closeModal"
				@create-employee="deleteCommitee"
			>
				<v-layout wrap mb-5 v-if="actionIs('delete')">
					<v-flex xs12>
						<h1 class="title-modal">Eliminar Comité</h1>
					</v-flex>
					<v-flex xs12 info--text bold-1>
						¿Desea eliminar el comité "{{ commiteeName }}" del listado?
					</v-flex>
				</v-layout>
			</open-modal>
		</div>
		<router-view name="newCommiteeForm"></router-view>
	</div>
</template>

<script>
	import appButton from '@/components/shared/app-button';
	import openModal from '@/components/configuration/open-modal';

	function created() {
		this.loadCommitted();
	}

	function actionIs(action, orAction) {
		return this.action === action || this.action === orAction;
	}

	async function loadCommitted() {
		const params = {
			search: this.search,
			typeGroup: 3,
		};
		try {
			const { data: response } = await this.$httpPraktiko.get(
				'groups', { params });
			this.rows = response;
		} catch (error) {
			if (error.status === 500) {
				this.showGenericError();
			}
		}
	}

	function onSearch(searchVal) {
		const newSearch = searchVal ? searchVal.trim() : null;
		this.search = newSearch;
		this.loadCommitted();
	}

	function openModalCom(action, id, name) {
		this.openDialog = true;
		this.idCommitee = id;
		if (action === 'delete') {
			this.action = action;
			this.commiteeName = name;
			this.title = 'Eliminar';
		}
	}

	function editCommitee({ id }) {
		this.goTo('new-commitees', { params: { id } });
	}

	function closeModal() {
		this.openDialog = false;
		this.action = null;
	}

	async function deleteCommitee() {
		try {
			await this.$httpPraktiko.delete(`group/${this.idCommitee}`);
			this.showNotification('Se elimino correctamente el comité');
			this.closeModal();
			this.loadCommitted();
		} catch (error) {
			this.showGenericError();
		}
	}

	function openDialogQuantity({ jobs, committeeEmployees, diagnosticEmployees }) {
		this.isVisible = true;
		this.arrayJobs = jobs;
		this.arrayEmployes = committeeEmployees;
		this.arrayDiagnostic =
			diagnosticEmployees.map(diagnostic => diagnostic.additionalInformation.jobs);
	}

	function closeDialog() {
		this.isVisible = false;
	}

	function data() {
		return {
			newArray: [],
			action: null,
			arrayDiagnostic: [],
			arrayJobs: [],
			arrayEmployes: [],
			columns: [
				{ id: 1, name: 'Nombre de Comité', visible: true, checked: true },
				{ id: 2, name: 'Fecha', visible: true, checked: true },
				{ id: 3, name: 'Cantidad de Puestos', visible: true, checked: true },
				{ id: 4, name: 'Cantidad por Valoradores', visible: true, checked: true },
				{ id: 5, name: 'Acciones', visible: true, checked: true },
			],
			commiteeName: '',
			isVisible: false,
			rows: [],
			search: null,
			title: '',
			openDialog: false,
		};
	}

	export default {
		name: 'page-commitees-list',
		created,
		data,
		components: {
			appButton,
			openModal,
		},
		methods: {
			actionIs,
			closeModal,
			closeDialog,
			deleteCommitee,
			editCommitee,
			loadCommitted,
			openDialogQuantity,
			onSearch,
			openModalCom,
		},
	};
</script>

<style lang="scss" scoped>
.triangle-right {
	color: white;
	width: 0;
  height: 0;
  border-top: 85px solid #55ac4b;
  border-left: 180px solid transparent;
  background: transparent;
	position: absolute;
	top: 35px;
}

.triangle-left {
	color: white;
	width: 0;
	height: 0;
	border-right: 180px solid transparent;
	border-bottom: 85px solid #f09c2b;
	background: transparent;
	position: relative;
}

.label-val {
	left: 21px;
	position: relative;
	top: 43px;
}

.label-pue {
	right: 20px;
	color: white;
	bottom: 45px;
	position: absolute;
}

.text-blue {
	color: #487fff;
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/pages/commitees/page-commitees-list.vue